import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { isServerPath } from "./serverPaths";

/**
 * A link to either an app route ("/find-research-analyst", "/signup?role=ra")
 * or a page of the server-rendered site ("/stocks/tcs"), which the router
 * doesn't know and must load as a normal page.
 */
export function SiteLink({
  to,
  className,
  children,
  onClick,
}: {
  to: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
}) {
  if (isServerPath(to)) {
    return (
      <a href={to} className={className} onClick={onClick}>
        {children}
      </a>
    );
  }
  const [path, query] = to.split("?");
  const search = Object.fromEntries(new URLSearchParams(query ?? ""));
  return (
    // Paths here come from the menus' own constants; the router checks them at runtime.
    <Link to={path as "/"} search={search as never} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
